var _rect, _rect2, _rect3, _path, _path2, _rect4, _rect5, _rect6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconCertificates(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 70,
    height: 70,
    rx: 16,
    fill: "#EAF3FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.492289,
    y: 1.32649,
    width: 26.4119,
    height: 26.6042,
    rx: 3,
    transform: "matrix(0.908751 0.417338 -0.416462 0.909153 32.778 8.91506)",
    fill: "#EAF3FA",
    stroke: "#413D45",
    strokeWidth: 2
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 19,
    y: 15.3781,
    width: 30.2688,
    height: 38.8738,
    rx: 3,
    fill: "#C7DFF2",
    stroke: "#413D45",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.3625 50.7621C28.2175 50.764 27.1025 50.1463 26.1816 49V58.671C26.1816 59.1208 26.7291 59.3419 27.0414 59.0182L28.6439 57.3578C29.0371 56.9504 29.6898 56.9504 30.083 57.3578L31.6855 59.0183C31.9978 59.3419 32.5453 59.1208 32.5453 58.671V49C31.6239 50.1472 30.5081 50.7649 29.3625 50.7621Z",
    fill: "#413D45",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0891 52.1916C32.0593 52.1916 34.4672 49.7837 34.4672 46.8134C34.4672 43.8432 32.0593 41.4353 29.0891 41.4353C26.1188 41.4353 23.7109 43.8432 23.7109 46.8134C23.7109 49.7837 26.1188 52.1916 29.0891 52.1916Z",
    fill: "#6CA5D4",
    stroke: "#413D45",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4541,
    y: 22.9832,
    width: 20.4369,
    height: 2.15125,
    rx: 1,
    fill: "#413D45"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4541,
    y: 28.3612,
    width: 20.4369,
    height: 2.15125,
    rx: 1,
    fill: "#413D45"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 24.4541,
    y: 33.7394,
    width: 11.8319,
    height: 2.15125,
    rx: 1,
    fill: "#413D45"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCertificates);
export default __webpack_public_path__ + "static/media/icon-certificates.e8149894873404ad90cb2a034fdf8086.svg";
export { ForwardRef as ReactComponent };